import { render, staticRenderFns } from "./StatisticsList.vue?vue&type=template&id=edc4b6f8&scoped=true&"
import script from "./StatisticsList.vue?vue&type=script&lang=js&"
export * from "./StatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsList.vue?vue&type=style&index=0&id=edc4b6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc4b6f8",
  null
  
)

export default component.exports